import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { initReactI18next } from 'react-i18next'
import App from './App'
import reportWebVitals from './reportWebVitals'

// Handle /health endpoint - return JSON before React loads
if (window.location.pathname === '/health') {
  const healthData = {
    status: 'healthy',
    service: 'airmotors-selector',
    timestamp: new Date().toISOString(),
    version: '1.0.0',
  }
  
  // Write JSON response
  document.open('text/plain', 'replace')
  document.write(JSON.stringify(healthData, null, 2))
  document.close()
} else {
  i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  // .use(detector)
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    debug: true,
    lng: 'en', // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  })

  const Loader = () => <div></div>

  ReactDOM.render(
    <Suspense fallback={<Loader />}>
      <App />
    </Suspense>,
    document.getElementById('root')
  )

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals()
}
